// extracted by mini-css-extract-plugin
export default {"root":"PersonalAccounts_root__iptWs","indent":"PersonalAccounts_indent__MgiX9"};